const HANDLERS_PROPERTY = "__v-click-outside";
const IS_TOUCH =
  typeof window !== "undefined" &&
  ("ontouchstart" in window ||
    (typeof navigator !== "undefined" && navigator.msMaxTouchPoints > 0));

const EVENTS = IS_TOUCH ? ["touchstart"] : ["click"];

const clickHandler = (e, el, callback) => {
  if (el.contains(e.target)) return;
  callback();
};

const bind = (el, binding) => {
  const { value } = binding;
  const element = el;

  if (!value || typeof value !== "function") {
    throw new Error(`v-click-outside: binding value must be a function.`);
  }

  element[HANDLERS_PROPERTY] = EVENTS.map(name => ({
    event: name,
    handler: e => clickHandler(e, el, value)
  }));

  element[HANDLERS_PROPERTY].forEach(({ event, handler }) => {
    setTimeout(() => {
      if (!element[HANDLERS_PROPERTY]) return;
      document.documentElement.addEventListener(event, handler, false);
    }, 0);
  });
};

const unbind = el => {
  const handlers = el[HANDLERS_PROPERTY] || [];

  handlers.forEach(({ event, handler }) =>
    document.documentElement.removeEventListener(event, handler, false)
  );

  delete el[HANDLERS_PROPERTY];
};

export const clickOutside = {
  inserted: bind,
  unbind,

  update(el, binding) {
    const { value, oldValue } = binding;
    if (JSON.stringify(value) === JSON.stringify(oldValue)) return;

    unbind(el);
    bind(el, binding);
  }
};
